import { useTranslation } from 'react-i18next';

/** Turns an ApiError into a message in the current language. */
export const useApiError = () => {
  const { t } = useTranslation();

  return (error) => {
    if (!error) return '';
    const key = `errors.${error.code}`;
    const translated = t(key);
    const base = translated === key ? error.message || t('common.error') : translated;
    if (Array.isArray(error.details) && error.details.length) {
      return `${base} (${error.details.length})`;
    }
    return base;
  };
};
